interface AppConfig {
  API_BASE_URL: string
  KEYCLOAK_URL: string
  KEYCLOAK_REALM: string
  KEYCLOAK_CLIENT_ID: string
  /** Set by the backend when it runs without authentication (local development only). */
  AUTH_DISABLED?: boolean
}

declare global {
  interface Window {
    __CONFIG__: AppConfig
  }
}

export function getConfig(): AppConfig {
  return window.__CONFIG__
}
